import { GeneratorInstanceService } from '@services/generatorInstanceService'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { GeneratorInstanceDto } from '@services/dtos'

export interface GeneratorInstanceState {
  instancesById: Record<number, GeneratorInstanceDto>
  loading: boolean
}

const initialState: GeneratorInstanceState = {
  instancesById: {},
  loading: false,
}

export const getGeneratorInstance = createAsyncThunk<GeneratorInstanceDto, string>(
  'generator-instance/find',
  async (id) => GeneratorInstanceService.getOne(id),
)

export const generatorInstanceReducer = createSlice({
  name: 'generator-instance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGeneratorInstance.pending, (state) => {
        state.loading = true
      })
      .addCase(getGeneratorInstance.rejected, (state) => {
        state.loading = false
      })
      .addCase(getGeneratorInstance.fulfilled, (state, action) => {
        state.instancesById[action.payload.id] = action.payload
        state.loading = false
      })
  },
})

export default generatorInstanceReducer.reducer
